import { z } from 'zod';
import { authProviderSchema } from './identity.js';
export const appProfileSchema = z.enum(['local', 'cloud']);
export const livenessResponseSchema = z.object({
    status: z.literal('ok'),
});
export const readinessCheckSchema = z.object({
    name: z.string(),
    status: z.enum(['ok', 'fail']),
    message: z.string().optional(),
});
export const readinessResponseSchema = z.object({
    status: z.enum(['ok', 'fail']),
    checks: z.array(readinessCheckSchema),
});
export const versionResponseSchema = z.object({
    appName: z.literal('pamagochi-api'),
    apiVersion: z.string(),
    commitSha: z.string(),
    buildTime: z.string(),
    appProfile: appProfileSchema,
    authProvider: authProviderSchema,
});
//# sourceMappingURL=meta.js.map